<template>
  <v-container fluid >
    <v-row justify="center" style="height:100%">
      <v-card
        tile
        style="border-radius: 25px 25px 0 0; pr-0"
        width="540px"
        height="97%"
      >
        <v-container
          class="fluid"
          :style="bcgColor"
          style=" width:100%;height: 70px"
        >
          <v-row
            style="width:100%; "
            justify="end"
            align="center"
            light
          >
            <v-btn icon @click="cancelClick">
              <CloseIcon style="fill:#0247A7" />
            </v-btn>
          </v-row>
        </v-container>
        <v-container
          class="fluid pr-2 pl-6 pb-5"
          :style="bdyColor"
          style=" width:100%;height: 91%"
          id="modalContainer"
        >
          <v-row
            style="width:100%"
            align="center"
            justify="center"
          >
            <span :style="titleProps">{{ titleText }}</span>
          </v-row>
          <v-row
            style="height:;width:100%"
            align="center"
            justify="center"
          >
            <v-col>
              <p :style="msgProps" class="mb-0 ft_depend_height">{{ msgText }}</p>
            </v-col>
          </v-row>


          <!--          /* discount with only sms */-->
          <v-row
            style="width:102.5%;"
            align="center"
            justify="center"
          >
          </v-row>

          <v-col cols="12" class="px-0 d-flex justify-center"  v-if="isDisc">
            <v-col cols="11" class="px-0">
              <v-row
                style="width:100%; border: 1px solid #C9CACB; "
                class="pa-0 my-0"

              >
                <v-col cols="3" class="ma-0 pa-0" style="height:100%;width:100%">
                  <v-img
                    :src="discImgSrc"
                    class="ma-0 pa-0"
                    height="100%"
                    width="100%"
                    style="background:#4E5D6B"
                  >
                  </v-img>
                </v-col>
                <v-col cols="9" class="fl_direction py-0"  v-if="checkOptin">
                  <v-row style="width:100%; padding-left:12px;">
                    <span style="font-weight:bold;font-size:120%; color:#5686F6">
                      {{ dscntCd }}
                    </span>
                  </v-row>

                  <v-row
                    style="width:100%; padding-left:12px;"
                    align="center"
                  >
                      <span>
                        {{ dscntInstr }}
                      </span>
                  </v-row>
                  <v-row style="width:100%; padding-left:12px;" align="start">
                    <v-btn
                      :style="buttonProps"
                      outlined
                      v-clipboard:copy="dscntCd"
                      v-clipboard:success="cpySuccess"
                    >
                      <span :style="btnTextProps">
                        {{ cpyBtnTxt }}
                      </span>
                    </v-btn>
                  </v-row>
                </v-col>
                <v-col cols="9"   v-if="!checkOptin" class="py-0">
                  <v-row
                    style="width:100%; "
                    class="pl-2"
                  >
                    <span style="font-weight:bold; font-size:82%;text-align: start !important;" class="mb-2 ml-1 ft_sz_17" :style="msgProps">
                      {{ dscntStmt }}
                    </span>
                  </v-row>
                  <v-row
                    style="width:100%;height: 60px; padding-left:12px;"
                    class=" wdg_view_sms_tel"
                  >
                    <v-row style="width:100%; height:100%;">
                      <v-col cols="12" style="height:100%" class="d-flex justify-center">
                        <!--                    <vue-tel-input-->
                        <!--                      v-model="optinNum"-->
                        <!--                      dark-->
                        <!--                      style="width:100%;"-->
                        <!--                      placeholder=""-->
                        <!--                      :showDialCode="true"-->
                        <!--                      mode="international"-->
                        <!--                      :class="{ 'alerts-border': displaeErr }"-->
                        <!--                      :style="telNumErr"-->
                        <!--                    >-->
                        <!--                    </vue-tel-input>-->


                        <v-col cols="12" class="px-0 py-0" >
                          <vue-tel-input
                            v-model="whatsappNumber"
                            dark
                            style="width:100%; height:35px !important ;"
                            :showDialCode="true"
                            mode="international"
                            :class="{ 'alerts-border': displaeErr }"
                            :style="telNumErr"
                            type="number"
                            v-on:country-changed="countryChanged"
                            @onValidate="btnDisabled = $event.valid"
                            @keydown="checkValidNumber($event)"
                            required
                            placeholder=""
                            :label="$t('settingsPage.addYourPhoneNumber')"
                            class="phone_number_section"
                          >
                            <!--                            :placeholder="$t('settingsPage.addYourPhoneNumber')"-->
                          </vue-tel-input>
<!--                          <vue-tel-input-vuetify-->
<!--                            type="number"-->
<!--                            v-model="whatsappNumber"-->
<!--                            v-bind="bindProps"-->
<!--                            v-on:country-changed="countryChanged"-->
<!--                            @onValidate="btnDisabled = $event.valid"-->
<!--                            @keydown="checkValidNumber($event)"-->
<!--                            required-->
<!--                            :placeholder="$t('settingsPage.addYourPhoneNumber')"-->
<!--                            label=""-->
<!--                            class="phone_number_section"-->

<!--                            :class="{ 'alerts-border': displaeErr }"-->
<!--                          >-->
<!--                          </vue-tel-input-vuetify>-->
                        </v-col>

                      </v-col>
                    </v-row>
                  </v-row>
                  <v-row style="width:100%; padding-left:12px;" align="start">
                    <v-btn
                      :style="buttonProps"
                      outlined
                      :key="widgetKey"
                      @click.once="submitClickDisc"
                      class="spc_ipad"
                    >
                        <span :style="btnTextProps">
                          {{ buttonText }}
                        </span>
                    </v-btn>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-col>

          <!--          /* No Discount with only sms */-->
          <v-row
            style="width:100%; "
            align="end"
            justify="center"
            v-if="!isDisc"
            class="wdg_view_sms_tel pb-2"

          >

            <v-col class="py-0">
              <v-col class="d-flex py-0 justify-center fx_height_pc_tel">

                <v-col cols="12" class="" >
                  <vue-tel-input
                    v-model="whatsappNumber"
                    dark
                    style="width:100%; height:35px !important ;"
                    :showDialCode="true"
                    mode="international"
                    :class="{ 'alerts-border': displaeErr }"
                    :style="telNumErr"
                    type="number"
                    v-on:country-changed="countryChanged"
                    @onValidate="btnDisabled = $event.valid"
                    @keydown="checkValidNumber($event)"
                    required
                    placeholder=""
                    :label="$t('settingsPage.addYourPhoneNumber')"
                    class="phone_number_section"
                  >
                    <!--                            :placeholder="$t('settingsPage.addYourPhoneNumber')"-->
                  </vue-tel-input>
<!--                  <vue-tel-input-vuetify-->
<!--                    type="number"-->
<!--                    v-model="whatsappNumber"-->
<!--                    v-bind="bindProps"-->
<!--                    v-on:country-changed="countryChanged"-->
<!--                    @onValidate="btnDisabled = $event.valid"-->
<!--                    @keydown="checkValidNumber($event)"-->
<!--                    required-->
<!--                    :placeholder="$t('settingsPage.addYourPhoneNumber')"-->
<!--                    label=""-->
<!--                    class="phone_number_section"-->
<!--                    v-show="loadReady"-->
<!--                    :class="{ 'alerts-border': displaeErr }"-->
<!--                    style="height: 50px !important;"-->
<!--                  >-->
<!--                  </vue-tel-input-vuetify>-->
                </v-col>
              </v-col>
              <v-col class="d-flex justify-center py-0 mt-2" >
                <v-col cols="7" class="py-0" >
                  <v-btn
                    :style="buttonProps"
                    outlined
                    :key="widgetKey"
                    @click.once="submitClick"
                    class="spc_ipad btn_height_50"
                  >
                    <span :style="btnTextProps">
                      {{ buttonText }}
                    </span>
                  </v-btn>
                </v-col>
              </v-col>

            </v-col>

            <!--            <vue-tel-input-->
            <!--              v-model="optinNum"-->
            <!--              dark-->
            <!--              style="width:100%"-->
            <!--              placeholder=""-->
            <!--              :showDialCode="true"-->
            <!--              mode="international"-->
            <!--              :class="{ 'alerts-border': displaeErr }"-->
            <!--              :style="telNumErr"-->
            <!--            >-->
            <!--            </vue-tel-input>-->
          </v-row>

          <v-row style="width:100%" v-if="!isDisc"> </v-row>

          <v-row
            style="hwidth:100%"
            align="center"
            justify="center"
            v-if="!checkOptin"
            class="mt-3 mr-1"
          >
            <a :style="cancelProps" @click="cancelClick">{{ cancelText }}</a>
          </v-row>

          <v-row
            style="width:100%"
            align="center"
            justify="center"
            v-if="checkOptin"
            class="mt-3"
          >
            <a :style="cancelProps" @click="cancelClick">Close</a>
          </v-row>
        </v-container>
      </v-card>
    </v-row>
    <!-- <v-alert light v-if="retCpyDone" style="margin-top:5%;" dense text outlined>
      Discount Code Copied Successfully
    </v-alert> -->
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import CloseIcon from "@/assets/icons/close.svg";
;

export default {
  name: "WidgetView",
  components: { CloseIcon },
  data() {
    return {
      dialog: false,
      btnId: 0,
      whatsappNumber: "",
      didOptIn: false,
      cpyDone: false,
      btnDisabled: false,
      bindProps: {
        mode: "international",
        placeholder: "Enter a phone number",
        required: false,
        enabledCountryCode: true,
        enabledFlags: true,
        autocomplete: "off",
        name: "telephone",
        maxLen: 25,
        inputOptions: {
          showDialCode: true
        },
        reg:null,
      },
      disButtonStyle:{
        "background-color":'rgb(0 106 255) !important',
        "width": "100%",
      },
      disButtonStyleDisabled:{
        "background-color":'rgb(185 185 185 / 60%) !important',
        "width": "100%",
        "border":"0px"
      },
      bindPropsSec: {
        "background-color":'rgb(0, 106, 255) !important',
        "width": "50%",
        "margin":"0px auto"
      },
      disButtonStyleSec:{
        "background-color":'rgba(0,0,0,.12)!important',
        "width": "50%",
        "margin":"0px auto"
      },
      loadReady:false,
    };
  },
  methods: {
    countryChanged(country) {
      setTimeout(()=> {this.whatsappNumber == '' ? this.whatsappNumber = '+' + country.dialCode : this.whatsappNumber.length > 4 && this.first == true ? this.whatsappNumber = '+' + country.dialCode: this.whatsappNumber,
        this.btnDisabled = false},300)
      if(country.dialCode !== null){
        this.country = '+' + country.dialCode
      }
    },
    checkValidNumber(event){
      switch (event.code){
        case 'Backspace':

          break;
        case 'Delete':

          break;
        case 'ArrowUp':

          break;
        case 'ArrowDown':

          break;
        case 'ArrowLeft':

          break;
        case 'ArrowRight':

          break;
        default: (/[a-zA-Z]/).test( event.key) == true ? event.preventDefault() : ''
      }
    },
    incrBtnId() {
      this.btnId++;
    },
    toggleDialog() {
      this.dialog = !this.dialog;
    },
    resetChanges() {
      this.$store.dispatch("getWidgets");
    },
    cancelClick() {
      this.$store.dispatch("toggleDisplay");
    },
    submitClick() {
      if (this.whatsappNumber != "" && this.btnDisabled == true) {
        // console.log(this.optinNum);
        this.didOptIn = true;
        let obj = {
          instance_id: document.querySelector("widget-view").instance_id,
          cart_id: document.querySelector("widget-view").cart_id,
          user_ref: this.whatsappNumber,
        };
        this.$store.dispatch("sendWaOptin", obj);
        this.$store.dispatch("toggleDisplay");
      } else {
        this.$store.dispatch("setErrFlashFB", true).then(() => {
          this.incrBtnId();
          setTimeout(() => {
            this.$store.dispatch("setErrFlashFB", false);
          }, 1000);
        });
      }
    },
    submitClickDisc() {
      if (this.whatsappNumber != "" && this.btnDisabled == true) {
        // console.log(this.optinNum);
        this.didOptIn = true;
        let obj = {
          instance_id: document.querySelector("widget-view").instance_id,
          cart_id: document.querySelector("widget-view").cart_id,
          user_ref: this.whatsappNumber,
        };
        this.$store.dispatch("sendWaOptin", obj);
        // this.$store.dispatch("toggleDisplay");
      } else {
        this.$store.dispatch("setErrFlashFB", true).then(() => {
          this.incrBtnId();
          setTimeout(() => {
            this.$store.dispatch("setErrFlashFB", false);
          }, 1000);
        });
      }
    },
    cpySuccess() {
      this.cpyDone = true;
      setTimeout(() => {
        this.cpyDone = false;
      }, 1500);
    },
  },
  computed: {
    ...mapGetters(["getWidgetsState", "getFbDetails", "getCheckBoxRendered"]),

    discImgSrc() {
      return `${process.env.VUE_APP_CLOUD_STORAGE_URL}/widget/img/discount-icon.png`;
    },

    cpyBtnTxt() {
      if (this.cpyDone) {
        return "COPIED!";
      } else {
        return "COPY DISCOUNT CODE";
      }
    },

    displaeErr() {
      return this.$store.getters.getErrFlashFB;
    },

    telNumErr() {
      let obj = { "border-color": "#ff0000" };
      if (this.$store.getters.getErrFlashFB) {
        return obj;
      } else {
        return {};
      }
    },
    getMessengerId() {
      return this.getFbDetails.messenger_app_id;
    },
    checkOptin() {
      return this.didOptIn;
    },
    isDisc() {
      return this.getWidgetsState.subscribe_type == "subscribe" ? true : false;
    },
    getFbPgId() {
      return this.getFbDetails.page_id;
    },
    detectChange() {
      return this.getWidgetsState.changesSaved;
    },

    dscntStmt() {
      return this.getWidgetsState.discount_statement;
    },
    dscntCd() {
      return this.getWidgetsState.discount_code;
    },
    dscntInstr() {
      return this.getWidgetsState.apply_discount_instruction;
    },

    bcgColor() {
      let hdrClsObj = {
        "background-color": this.getWidgetsState.header_background_color,
      };
      return hdrClsObj;
    },
    bdyColor() {
      let bdyClsObj = {
        "background-color": this.getWidgetsState.popup_background_color,
      };
      return bdyClsObj;
    },
    titleText() {
      return this.getWidgetsState.pop_up_title;
    },
    titleProps() {
      let ttlObj = {
        color: this.getWidgetsState.pop_up_title_font_color,
        "font-weight": this.getWidgetsState.pop_up_title_font_type,
        "font-size": this.getWidgetsState.pop_up_title_font_size + "px",
        "font-family": this.getWidgetsState.pop_up_title_font_family,
      };
      return ttlObj;
    },
    msgText() {
      return this.getWidgetsState.pop_up_message;
    },
    msgProps() {
      let ttlObj = {
        color: this.getWidgetsState.pop_up_message_font_color,
        "font-weight": this.getWidgetsState.pop_up_message_font_type,
        "font-size": this.getWidgetsState.pop_up_message_font_size + "px",
        "font-family": this.getWidgetsState.pop_up_message_font_family,
        "text-align": "center",
      };
      return ttlObj;
    },
    cancelText() {
      return this.getWidgetsState.pop_up_cancel;
    },
    cancelProps() {
      let ttlObj = {
        color: this.getWidgetsState.pop_up_cancel_font_color,
        "font-weight": this.getWidgetsState.pop_up_cancel_font_type,
        "font-size": this.getWidgetsState.pop_up_cancel_font_size + "px",
        "font-family": this.getWidgetsState.pop_up_cancel_font_family,
        "text-decoration": "underline",
        "text-align": "center",
      };
      return ttlObj;
    },
    buttonText() {
      this.incrBtnId();

      return this.getWidgetsState.button_text;
    },
    buttonProps() {
      let borderRad =
        this.getWidgetsState.button_corners == "Round" ? "4px" : "0px";
      let buttonObj = {
        "background-color": this.getWidgetsState.button_background,
        "border-color": this.getWidgetsState.button_border_color,
        "border-radius": borderRad,
        "border-width": this.getWidgetsState.button_border_size + "px",
        width: "100%",
      };
      return buttonObj;
    },
    btnTextProps() {
      let btnObj = {
        color: this.getWidgetsState.button_font_color,
        "font-family": this.getWidgetsState.button_font_family,
        "font-weight": this.getWidgetsState.button_font_type,
        "font-size": this.getWidgetsState.button_font_size + "px",
        "text-transform": "none",
      };
      return btnObj;
    },
    widgetType() {
      return this.getWidgetsState.facebook_widget_type;
    },
    widgetKey() {
      return "key" + this.getWidgetsState.wdgt_key_internal + "b" + this.btnId;
    },
    checkRendered() {
      return this.getCheckBoxRendered;
    },
    retCpyDone() {
      return this.cpyDone;
    },
  },
  beforeCreate() {
    this.$store.dispatch("getWidgets");
  },
};
</script>

<style>
.ft_sz_17{
  font-size: 17px !important;
}
.btn_height_50{
  height: 50px !important;
}
.fx_height_pc_tel{
  height: 40px !important;
}
.fx_height_pr_tel{
  height: 165px !important;
}
[data-vuetify] .v-input__slot{
  margin-bottom: 0px !important;
}
[data-vuetify] .theme--dark.v-input input, [data-vuetify] .theme--dark.v-input textarea{
  color: black !important;
}
[data-vuetify] .theme--dark.v-label {
  color: rgb(0 0 0) !important;
}
[data-vuetify] .theme--dark.v-placeholder {
  color: rgb(0 0 0) !important;
}
.vue-tel-input-vuetify {
  /*height: 35px !important;*/
  /*border-bottom: 1px solid black !important;*/
  /*border-radius: 3px !important;*/
  /*display: flex !important;*/
  /*border: 1px solid #bbb !important;*/
  /*text-align: left !important;*/

  border-radius: 3px;
  display: flex;
  border: 1px solid #bbb;
  text-align: left;
}
.vue-tel-input-vuetify:focus-within {
  box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%), 0 0 8px rgb(102 175 233 / 60%);
  border-color: #66afe9;
}
[data-vuetify] .v-application .white--text{
  color: #00000000 !important;
}
[data-vuetify] .v-application .white--text{
  color: #00000000 !important;
}
[data-vuetify] .theme--dark.v-icon {
  color: #000000 !important;
}
[data-vuetify] .v-application .white--text{
  color: #00000000 !important;
}
.focus-visible{
  border-bottom: 0px !important;
}
.vue-tel-input {
  border-radius: 3px;
  display: flex;
  border: 1px solid #bbb;
  text-align: left;
}
</style>
